import React from 'react';
import { RefreshCw, WifiOff, X } from 'lucide-react';
import usePwa from '../hooks/usePwa';

/**
 * Global PWA chrome: offline pill, update toast.
 * Automatic install popups removed per user preference.
 */
export default function PwaChrome() {
  const {
    online,
    updateAvailable,
    applyUpdate,
    dismissUpdate,
  } = usePwa();

  return (
    <>
      {!online && (
        <div
          className="fixed top-0 inset-x-0 z-[1100] px-3 py-2 text-center text-xs font-medium bg-amber-500/95 text-neutral-950 shadow"
          role="status"
          aria-live="polite"
        >
          <span className="inline-flex items-center gap-1.5">
            <WifiOff className="w-3.5 h-3.5" />
            You’re offline — cached shell stays available; queued actions sync when you’re back.
          </span>
        </div>
      )}

      {updateAvailable && (
        <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[1100] w-[min(92vw,28rem)]">
          <div className="rounded-xl border border-emerald-500/40 bg-neutral-900/95 backdrop-blur shadow-lg shadow-black/40 p-3 flex items-start gap-3">
            <RefreshCw className="w-5 h-5 text-emerald-400 mt-0.5 flex-shrink-0" />
            <div className="flex-1 min-w-0">
              <p className="text-sm font-semibold text-slate-100">Update available</p>
              <p className="text-xs text-slate-400 mt-0.5">
                A newer Testera build is ready. Reload to get the latest shell.
              </p>
              <div className="mt-2.5 flex gap-2">
                <button
                  type="button"
                  onClick={applyUpdate}
                  className="px-3 py-1.5 rounded-lg bg-emerald-600 hover:bg-emerald-500 text-white text-xs font-semibold"
                >
                  Reload
                </button>
                <button
                  type="button"
                  onClick={dismissUpdate}
                  className="px-3 py-1.5 rounded-lg border border-neutral-700 text-slate-300 hover:text-white text-xs"
                >
                  Later
                </button>
              </div>
            </div>
            <button
              type="button"
              onClick={dismissUpdate}
              className="text-slate-500 hover:text-slate-200"
              aria-label="Dismiss update"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
        </div>
      )}
    </>
  );
}
